import getRoutes from '../../../config/clientRoutes/getRoutes';
import { TrajectoryViewPage } from '../../trajectory/scenes';
import { StudentDashboardPage } from '../../student-dashboard/scenes';
import { lazyWithRetry } from 'src/modules/shared/helpers/lazyRetry';
import { TableOfContents } from 'src/pages/table-of-contents/TableOfContents';
import { TOCSearch } from 'src/pages/table-of-contents/search/TOCSearch';

const ScoringViewPage = lazyWithRetry(
  () => import('../../score-progression/scenes/ScoringViewPage')
);
const SupportPage = lazyWithRetry(() => import('../../support/scenes/SupportPage'));
const ContactMessagePage = lazyWithRetry(() => import('../../support/scenes/ContactMessagePage'));
const ProfilePage = lazyWithRetry(() => import('../../profile/scenes/ProfilePage'));
const TeacherManual = lazyWithRetry(() => import('../../manuals/components/TeacherManual'));
const GroupsPage = lazyWithRetry(() => import('../../groups/scenes/GroupsPage'));
const GradesPage = lazyWithRetry(() => import('../../grades-methods/scenes/GradesPage'));
const GradeDetailsPage = lazyWithRetry(
  () => import('../../grades-methods/scenes/GradeDetailsPage')
);
const CurriculumGoalDashboardPage = lazyWithRetry(
  () => import('../../curriculum-goal/scenes/CurriculumGoalDashboardPage')
);
const StudyCard = lazyWithRetry(() => import('src/modules/study-card/StudyCard'));
const AssignmentDashboardPage = lazyWithRetry(
  () => import('../../assignment/scenes/AssignmentDashboardPage')
);
const BooksPage = lazyWithRetry(() => import('../../book/scenes/BooksPage'));
const BookPage = lazyWithRetry(() => import('../../book/scenes/BookPage'));
const ChapterPage = lazyWithRetry(() => import('../../book/scenes/ChapterPage'));
const TrajectoryBuilderPage = lazyWithRetry(
  () => import('../../trajectory/scenes/TrajectoryBuilderPage')
);

export const privateRouteConfig = {
  books: {
    component: BooksPage,
    exact: true,
  },
  book: {
    component: BookPage,
    exact: true,
  },
  chapter: {
    component: ChapterPage,
    exact: true,
  },
  trajectory: {
    component: TrajectoryBuilderPage,
  },
  trajectoryView: {
    component: TrajectoryViewPage,
  },
  profile: {
    component: ProfilePage,
  },
  studentDashboard: {
    component: StudentDashboardPage,
    exact: true,
  },
  bookOverview: {
    component: TableOfContents,
    exact: true,
  },
  chapterOverview: {
    component: TableOfContents,
    exact: true,
  },
  tableOfContentsSearch: {
    component: TOCSearch,
    exact: true,
  },
  assignmentDashboard: {
    component: AssignmentDashboardPage,
  },
  curriculumGoalDashboard: {
    component: CurriculumGoalDashboardPage,
  },
  groups: {
    component: GroupsPage,
  },
  gradesManager: {
    component: GradesPage,
    exact: true,
  },
  gradeDetail: {
    component: GradeDetailsPage,
  },
  support: {
    component: SupportPage,
    exact: true,
  },
  contactMessage: {
    component: ContactMessagePage,
    exact: true,
  },
  teacherManual: {
    component: TeacherManual,
    exact: true,
  },
  studentScoring: {
    component: ScoringViewPage,
    exact: true,
  },
  studyCard: {
    component: StudyCard,
    exact: true,
  },
};

const getPrivateRoutes = getRoutes(privateRouteConfig);

export default getPrivateRoutes;
